export const SAVE_SORT_OPTIONS = {
    RECENT: 'recent',
    OLDEST: 'oldest',
    ALPHA_ASC: 'alpha_asc',
    ALPHA_DESC: 'alpha_desc',
};

// Read-status values accepted by the Saves filter (in addition to tag filters).
export const SAVE_READ_STATUS_FILTERS = {
    ALL: 'all',
    READ: 'read',
    UNREAD: 'unread',
};